import React from 'react';
import {
  withRouter,
} from 'react-router-dom';
import DOMPurify from 'dompurify';
import { connect } from 'react-redux';
import queryString from 'query-string';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import ThemeProvider from './Components/ThemeProvider';
import { getTheme } from './redux/theme';
import { getRace } from './redux/race';
import { confirmPurchaseCompleted, paddleClose } from './redux/signup';
import { setDefferedPrompt } from './redux/preferences';
import Routes from './Routes';
import createAndAddFavicon from './utils/createAndAddFavicon';

// Add a hook to make all sanitized links from the API open a new window
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
    // set all elements owning target to target=_blank
    if ('target' in node) {
        node.setAttribute('target', '_blank');
        // prevent https://www.owasp.org/index.php/Reverse_Tabnabbing
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

const App = ({ runnerId, theme, archived }) => (<div>
    <ThemeProvider theme={theme}>
        <Routes runnerId={runnerId} archived={archived} themeId={theme.themeId} />
    </ThemeProvider>
</div>);

App.propTypes = {
    runnerId: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.string,
    ]),
    theme: React.PropTypes.object,
    archived: React.PropTypes.oneOfType([
        React.PropTypes.number,
        React.PropTypes.boolean,
    ]),
};

export default compose(
    withRouter,
    connect(({ auth, theme, signup, race }) => ({
        runnerId: auth.runnerId,
        theme,
        planId: race.info ? race.info.planId : null,
        archived: auth.archived,
        email: signup.fields.email,
        userkey: signup.fields.password,
    }), { getRace, getTheme, setDefferedPrompt, confirmPurchaseCompleted, paddleClose }),
    lifecycle({
        componentWillMount() {
            window.addEventListener('beforeinstallprompt', (event) => {
                console.log('beforeinstallprompt fired from App');
                event.preventDefault();
                this.props.setDefferedPrompt(event);
                return false;
            });
        },
        componentWillReceiveProps(nextProps) {
            const nextParams = queryString.parse(nextProps.location.search);
            const currentParams = queryString.parse(this.props.location.search);
            if (nextParams.event !== currentParams.event && nextParams.event) {
                nextProps.getTheme(nextParams.event);
            }
            if (this.props.planId && (nextProps.planId !== this.props.planId)) {
                this.props.getRace();
            }
        },
        componentDidMount() {
            window.Paddle.Setup({
                vendor: 133173,
                debug: false,
                eventCallback: (data) => {
                    const passthroughObj = JSON.parse(data.eventData.checkout.passthrough);
                    if (data.event === 'Checkout.Complete') {
                        this.props.confirmPurchaseCompleted(passthroughObj);
                    }
                    if (data.event === 'Checkout.Close' && passthroughObj.fromSignup) {
                        this.props.paddleClose();
                    }
                },
            });
            if (this.props.planId) {
                this.props.getRace();
                return;
            }
            const params = queryString.parse(this.props.location.search);
            let event = params.event;
            let favicon = './favicon.ico';
            if (window.location.hostname === 'virtualtrainer.nyrr.org') {
                favicon = './nyrrFavicon.ico';
                document.title = 'Virtual Trainer';
                if (!event) {
                    event = '3';
                }
            } else {
                event = '0';
            }
            createAndAddFavicon(favicon);
            if (event) {
                this.props.getTheme(event);
            } else {
                this.props.getTheme();
            }
        },
        componentDidUpdate(prevProps) {
            if (this.props.location.pathname !== prevProps.location.pathname) {
                if (window.gtag) {
                    window.gtag('event', 'page_view', {
                        page_location: window.location.origin + this.props.location.pathname,
                        page_path: window.location.pathname,
                        page_title: document.title,
                    });
                }
            }
        },
        shouldComponentUpdate() {
            return true;
        },
    }),
)(App);



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/